import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["onCreateImpressionWhenView"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useImpressionObserver } from '@scentregroup/analytics';
import { LinkBox } from '@hub/link';
import React, { useImperativeHandle } from 'react';
import { forwardRef } from '@hub/design-system-base';
import { jsx as _jsx } from "react/jsx-runtime";
export const TrackLinkBox = forwardRef((_ref, ref) => {
  let {
      onCreateImpressionWhenView
    } = _ref,
    linkBoxProps = _objectWithoutProperties(_ref, _excluded);
  const {
    inViewRef
  } = useImpressionObserver({
    onCreateImpressionWhenView
  });
  useImperativeHandle(ref, () => ({
    focus: () => {
      inViewRef();
    }
  }));
  if (!onCreateImpressionWhenView) {
    return /*#__PURE__*/_jsx(LinkBox, _objectSpread(_objectSpread({}, linkBoxProps), {}, {
      "data-id": "analytics-observer_track-link-box_TrackLinkBox_LinkBox"
    }));
  }
  return /*#__PURE__*/_jsx(LinkBox, _objectSpread(_objectSpread({
    ref: inViewRef
  }, linkBoxProps), {}, {
    "data-id": "analytics-observer_track-link-box_TrackLinkBox_LinkBox_1"
  }));
});